// SPDX-FileCopyrightText: 2024 Chris Duncan <chris@zoso.dev>
// SPDX-License-Identifier: GPL-3.0-or-later
export const ACCOUNT_KEY_LENGTH = 64;
export const ADDRESS_GAP = 20;
export const ALPHABET = '13456789abcdefghijkmnopqrstuwxyz';
export const BIP39_ITERATIONS = 2048;
export const BIP44_PURPOSE = 44;
export const BIP44_COIN_NANO = 165;
export const BURN_ADDRESS = 'nano_1111111111111111111111111111111111111111111111111111hifc8npp';
export const HARDENED_OFFSET = 0x80000000;
export const NONCE_LENGTH = 24;
export const PREAMBLE = '0000000000000000000000000000000000000000000000000000000000000006';
export const PREFIX = 'nano_';
export const PREFIX_LEGACY = 'xrb_';
export const SEED_LENGTH_BIP44 = 128;
export const SEED_LENGTH_BLAKE2B = 64;
export const SLIP10_ED25519 = 'ed25519 seed';
export const XNO = 'Ӿ';
export const LEDGER_STATUS_CODES = Object.freeze({
    0x6700: 'INCORRECT_LENGTH',
    0x670a: 'NO_APPLICATION_SPECIFIED',
    0x6807: 'APPLICATION_NOT_INSTALLED',
    0x6d00: 'APPLICATION_ALREADY_LAUNCHED',
    0x6982: 'SECURITY_STATUS_NOT_SATISFIED',
    0x6985: 'CONDITIONS_OF_USE_NOT_SATISFIED',
    0x6a81: 'INVALID_SIGNATURE',
    0x6a82: 'CACHE_MISS',
    0x6b00: 'INCORRECT_PARAMETER',
    0x6e01: 'TRANSPORT_STATUS_ERROR',
    0x9000: 'OK'
});
export const UNITS = Object.freeze({
    RAW: 0,
    RAI: 24,
    NYANO: 24,
    KRAI: 27,
    PICO: 27,
    MRAI: 30,
    NANO: 30,
    KNANO: 33,
    MNANO: 36
});
